import { render, staticRenderFns } from "./TechnicalDetails.vue?vue&type=template&id=9c8898c2&scoped=true&"
import script from "./TechnicalDetails.vue?vue&type=script&lang=js&"
export * from "./TechnicalDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8898c2",
  null
  
)

export default component.exports